import { render, staticRenderFns } from "./TestPlanStatusEdit.vue?vue&type=template&id=ccf3712c&scoped=true"
import script from "./TestPlanStatusEdit.vue?vue&type=script&lang=js"
export * from "./TestPlanStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./TestPlanStatusEdit.vue?vue&type=style&index=0&id=ccf3712c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf3712c",
  null
  
)

export default component.exports